import { RouteLocationNormalized } from 'vue-router'
import Cookies from 'js-cookie'

const removeCookieConsent = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized
) => {
  const COOKIE_CONSENT_ACCEPTED = 'cookie_consent_accepted'
  const routeMeta = to.meta
  const cookieConsent = document.getElementById('termly-code-snippet-support')

  // cookie value from parent domain
  // ref: resources/jobscan-spa/src/lib/scanStorageCore.ts
  const consentCookie = Cookies.get(COOKIE_CONSENT_ACCEPTED)
  if ((routeMeta && routeMeta.removeCookieConsent) || consentCookie === 'true') {
    cookieConsent?.classList.add('hidden')
  } else {
    cookieConsent?.classList.remove('hidden')
  }
  return true
}

export default removeCookieConsent
